const awsExports = {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_g8wVE3vDQ",
    aws_user_pools_web_client_id: "29dt7ebk8j4bd45kp4q31mmtrq",
    aws_cognito_identity_pool_id: "us-east-1:b3dafc44-3caa-48d6-aa12-0cfc36b0f15e",
    oauth: {}
};

export default awsExports;